import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { clearSession } from "src/utils/session"

function Logout(): JSX.Element {
    const navigate = useNavigate()

    useEffect(() => {
        clearSession()
        navigate("/", { replace: true })
    }, [navigate])

    return <></>
}

export default Logout
